module.exports = __webpack_public_path__ + "img/20231005075354597jqs.50b159a9.jpg";